import { Injectable, Inject } from '@angular/core';
import { ShoppingCart, PaymentMethod } from '@ridango/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable( {
    providedIn: 'root'
} )
export class PaymentService {

    constructor(
        @Inject( 'ENV' ) private env: any,
        private http: HttpClient,

    ) { }


    requestInvoice ( cart: ShoppingCart, payment: PaymentMethod, lang: any = false ): Observable<any> {
        // /v2/{ region_id } /payment/{ payment_id }/cart/{ cart_id } /invoice
        let url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/payment/${payment.payment_id}/cart/${cart.shopping_cart_id}/invoice`;

        if (lang) {
            url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/payment/${payment.payment_id}/cart/${cart.shopping_cart_id}/invoice/${lang}`;
        }

        const payload: any = {};
        return this.http.put( url, payload );
    }
}
